<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <h2 class="mb-3 mt-sm-4">{{ $t('message.eCommerceV2.downPaymentHeading') }}</h2>
      <div class="row">
        <mobialis-text-input-with-validation
          class="mb-0 col-sm-6"
          :mask-type="languageCode === 'fr-CA' ? 'frenchInt' : 'moneyInt'"
          inputmode="numeric"
          pattern="[0-9]*"
          :label="$t('message.eCommerceV2.downPaymentLabel')"
          v-model="downPayment"
          vid="downPayment"
          data-cy="downPayment"
        ></mobialis-text-input-with-validation>
      </div>
      <div class="push-down-desktop">
        <mobialis-button type="submit" class="mt-5 mb-3" data-cy="continue">{{
          $t('message.common.continue')
        }}</mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapGetters } from 'vuex';

export default {
  name: 'DownPaymentForm',
  data() {
    return {
      downPayment: cloneDeep(this.$store.state.paymentCalculator.downPayment),
    };
  },
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
  },
  methods: {
    submit(isValid) {
      if (!isValid) {
        return;
      }
      this.$store.commit('paymentCalculator/SET_STATE', ['downPayment', this.downPayment]);
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped></style>
